import {
  hasMerchantPermission,
  shopMarketplaceApi,
} from "@/modules/merchant/presentation/api/client";
import { hasShopFeature } from "@/modules/merchant/presentation/lib/has-shop-feature";
import { MerchantPermissions } from "@/modules/roles/domain/contracts/merchant-permissions";
import type { ShopFeatureFlags } from "@/modules/merchant/domain/contracts/shop-feature-flags";
import { useQuery } from "@tanstack/react-query";

export function useMarketplacePendingOrdersBadge(
  shopId: string | undefined,
  currentPermissions: string[],
  featureFlags: ShopFeatureFlags | null | undefined,
) {
  const canRead =
    !!shopId &&
    hasShopFeature(featureFlags, "marketplace_sync") &&
    hasMerchantPermission(
      currentPermissions,
      MerchantPermissions.marketplace.read,
    );

  const { data } = useQuery({
    queryKey: ["shop-marketplace-pending-orders", shopId],
    queryFn: () => shopMarketplaceApi.stats(shopId!),
    enabled: canRead,
    refetchInterval: 60_000,
    select: (stats) => stats.pendingOrders,
  });

  if (!canRead || !data || data <= 0) return undefined;
  return data > 99 ? "99+" : String(data);
}
